<!--
 * @Author: your name
 * @Date: 2021-06-22 13:59:06
 * @LastEditTime: 2024-07-31 16:09:51
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\AttrList\AttrRss.vue
-->
<!--Rss-->

<template>
  <div class="attr-rss">
    <div class="rss-item flex-b-c">
      <span class="rss-attr">{{$t('PE.Name')}}</span>
      <span>RSS</span>
    </div>
    <div class="rss-item flex-b-c">
      <el-input :placeholder="$t('basics.PleaseInput')" v-model="media.ext_val_url" size="mini">
        <template slot="prepend">URL</template>
      </el-input>
    </div>
    <!-- <div class="rss-item flex-b-c">
      <span class="rss-attr">{{$t('PE.PlayTime')}}(s)</span>
      <el-input-number v-model="media.ext_val_duration" :min="1" :label="$t('PE.Describe')" size="mini"></el-input-number>
    </div> -->
    <div class="rss-item flex-b-c">
      <el-checkbox v-model="media.ext_val_isTitleShow">
        <span class="rss-attr">{{$t('PE.Title')}}</span>
      </el-checkbox>
      <div class="rss-attr-child" style="height: 96px;">
        <el-select v-model="media.ext_val_titleTextStyle" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
          <el-option v-for="item in familys" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select v-model="media.ext_val_titleTextSize" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
          <el-option v-for="item in fontSize" :key="item" :label="item+'px'" :value="item"></el-option>
        </el-select>
        <div class="flex-a-c">
          <img
            class="font-icon"
            :class="{'select-icon':media.ext_val_isTitleBold}"
            @click="fontSet('ext_val_isTitleBold')"
            :src="imgRequest('program_text_B.png')"
            alt
          />
          <img
            class="font-icon"
            :class="{'select-icon':media.ext_val_isTitleItalic}"
            @click="fontSet('ext_val_isTitleItalic')"
            :src="imgRequest('program_text_I.png')"
            alt
          />
          <img
            class="font-icon"
            :class="{'select-icon':media.ext_val_isTitleUnderLine}"
            @click="fontSet('ext_val_isTitleUnderLine')"
            :src="imgRequest('program_text_U.png')"
            alt
          />
          <el-color-picker class="font-color-picker" v-model="media.ext_val_titleColor" size="mini" :show-alpha="true" :predefine="predefineColors"></el-color-picker>
        </div>
      </div>
    </div>
    <div class="rss-item flex-b-c">
      <el-checkbox v-model="media.ext_val_isContentShow">
        <span class="rss-attr">{{$t('PE.Text')}}</span>
      </el-checkbox>
      <div class="rss-attr-child" style="height: 96px;">
        <el-select v-model="media.ext_val_contentTextStyle" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
          <el-option v-for="item in familys" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select v-model="media.ext_val_contentTextSize" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
          <el-option v-for="item in fontSize" :key="item" :label="item+'px'" :value="item"></el-option>
        </el-select>
        <div class="flex-a-c">
          <img
            class="font-icon"
            :class="{'select-icon':media.ext_val_isContentBold}"
            @click="fontSet('ext_val_isContentBold')"
            :src="imgRequest('program_text_B.png')"
            alt
          />
          <img
            class="font-icon"
            :class="{'select-icon':media.ext_val_isContentItalic}"
            @click="fontSet('ext_val_isContentItalic')"
            :src="imgRequest('program_text_I.png')"
            alt
          />
          <img
            class="font-icon"
            :class="{'select-icon':media.ext_val_isContentUnderLine}"
            @click="fontSet('ext_val_isContentUnderLine')"
            :src="imgRequest('program_text_U.png')"
            alt
          />
          <el-color-picker
            class="font-color-picker"
            v-model="media.ext_val_contentColor"
            size="mini"
            :show-alpha="true"
            :predefine="predefineColors"
          ></el-color-picker>
        </div>
      </div>
    </div>
    <div class="rss-item flex-b-c">
      <el-checkbox v-model="media.ext_val_isDateShow">
        <span class="rss-attr">{{$t('PE.Time')}}</span>
      </el-checkbox>
      <div class="rss-attr-child" style="height: 96px;">
        <el-select v-model="media.ext_val_dateTextStyle" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
          <el-option v-for="item in familys" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select v-model="media.ext_val_dateTextSize" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
          <el-option v-for="item in fontSize" :key="item" :label="item+'px'" :value="item"></el-option>
        </el-select>
        <div class="flex-a-c">
          <img
            class="font-icon"
            :class="{'select-icon':media.ext_val_isDateBold}"
            @click="fontSet('ext_val_isDateBold')"
            :src="imgRequest('program_text_B.png')"
            alt
          />
          <img
            class="font-icon"
            :class="{'select-icon':media.ext_val_isDateItalic}"
            @click="fontSet('ext_val_isDateItalic')"
            :src="imgRequest('program_text_I.png')"
            alt
          />
          <img
            class="font-icon"
            :class="{'select-icon':media.ext_val_isDateUnderLine}"
            @click="fontSet('ext_val_isDateUnderLine')"
            :src="imgRequest('program_text_U.png')"
            alt
          />
          <el-color-picker class="font-color-picker" v-model="media.ext_val_dateColor" size="mini" :show-alpha="true" :predefine="predefineColors"></el-color-picker>
        </div>
      </div>
    </div>
    <div class="rss-item">
      <div class="rss-attr">{{$t('PE.PlayTheWay')}}</div>
      <div class="flex-c-c play-m-item">
        <el-radio-group v-model="media.ext_val_scrollDirection" class="flex-b-c">
          <el-radio :label="index" v-show="media.ext_val_scrollDirection == index" v-for="index in 4" :key="index">{{$t('PE.Roll')}}</el-radio>
          <el-radio :label="1" v-show="media.ext_val_scrollDirection == 0 || media.ext_val_scrollDirection == 5">{{$t('PE.Roll')}}</el-radio>
          <el-radio :label="5">{{$t('PE.FlipOver')}}</el-radio>
          <el-radio :label="0">{{$t('PE.Motionless')}}</el-radio>
        </el-radio-group>
      </div>
      <div v-show="media.ext_val_scrollDirection >= 1 && media.ext_val_scrollDirection <= 4 " class="play-m">
        <div class="flex-b-c play-m-item">
          <span>{{$t('PE.Roll')}}</span>
          <el-select v-model="media.ext_val_scrollDirection" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
            <el-option v-for="item in directions" :key="item.value" :label="$t(item.label)" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="flex-b-c play-m-item">
          <span>{{$t('PE.RollingDirection')}}</span>
          <el-input-number v-model="media.ext_val_scrollSpeed" :min="1" :max="10" :label="$t('PE.Describe')" size="mini"></el-input-number>
        </div>
        <div class="flex-b-c play-m-item">
          <span>{{$t('PE.RollingVelocity')}}(s)</span>
          <el-input-number v-model="media.ext_val_duration" :min="1" :label="$t('PE.Describe')" size="mini"></el-input-number>
        </div>
        <!-- <div class="flex-b-c play-m-item">
          <span>连接方式</span>
          <el-checkbox v-model="media.ext_val_isLoop">首尾相连</el-checkbox>
        </div> -->
      </div>
      <div v-show="media.ext_val_scrollDirection === 5" class="flex-b-c play-m-item">
        <span>{{$t('PE.PlayTime')}}(s)</span>
        <el-input-number v-model="media.ext_val_duration" :min="1" :label="$t('PE.Describe')" size="mini"></el-input-number>
      </div>
      <div class="play-m-item flex-b-c">
      <span class="rss-attr">{{$t('PE.EnterTheAnimation')}}</span>
      <el-select v-model="media.ext_val_anim" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
        <el-option v-for="item in animations" :key="item.id" :label="$t(item.i18n)" :value="item.id"></el-option>
      </el-select>
    </div>
    <div class="play-m-item flex-b-c">
      <span class="rss-attr">{{$t('PE.TheEntryTime')}}(s)</span>
      <el-input-number v-model="media.ext_val_enterTime" :min="1" size="mini"></el-input-number>
    </div>
      <div v-show="media.ext_val_scrollDirection === 0" class="flex-b-c play-m-item">
        <span>{{$t('PE.PlayTime')}}(s)</span>
        <el-input-number v-model="media.ext_val_duration" :min="1" :label="$t('PE.Describe')" size="mini"></el-input-number>
      </div>
      <!-- <div class="flex-c-c play-m-item">
        <el-radio-group v-model="scrollType" @change="modeChange" class="flex-b-c">
          <el-radio label="0">滚动</el-radio>
          <el-radio label="5">翻页</el-radio>
        </el-radio-group>
      </div>
      <div v-show="scrollType === '0'" class="play-m">
        <div class="flex-b-c play-m-item">
          <span>滚动方向</span>
          <el-select v-model="media.ext_val_scrollDirection" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
            <el-option v-for="item in directions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="flex-b-c play-m-item">
          <span>滚动速度</span>
          <el-input-number v-model="num1" :min="0" :max="5" label="描述文字" size="mini"></el-input-number>
        </div>
        <div class="flex-b-c play-m-item">
          <span>播放时长(ms)</span>
          <el-input-number v-model="num" :min="1" :max="10" label="描述文字" size="mini"></el-input-number>
        </div>
      </div>
      <div v-show="scrollType === '5'" class="play-m">
        <div class="flex-b-c play-m-item">
          <span>入场特效</span>
          <el-select v-model="value" :placeholder="$t('basics.PleaseSelect')" size="mini" style="width:130px;">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
        <div class="flex-b-c play-m-item">
          <span>入场时间(s)</span>
          <el-input-number v-model="num" :min="1" :max="10" label="描述文字" size="mini"></el-input-number>
        </div>
        <div class="flex-b-c play-m-item">
          <span>每页时间(s)</span>
          <el-input-number v-model="num" :min="1" :max="10" label="描述文字" size="mini"></el-input-number>
        </div>
        <div class="flex-b-c play-m-item">
          <span>播放时间(s)</span>
          <el-input-number v-model="num" :min="1" :max="10" label="描述文字" size="mini"></el-input-number>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import familys from '@static/data/familys.js';
import fontSize from '@static/data/fontSize.js';
import animations from '../../scripts/animations';
import predefineColors from '@static/data/predefineColors.js';
const directions = [
  { value: 1, label: "PE.FromLeftToRight" },
  { value: 2, label: "PE.FromRightToLeft" },
  { value: 3, label: "PE.FromTopToBottom" },
  { value: 4, label: "PE.FromTheBottomUp" }
];
export default {
  name: "AttrRss",
  props: {
    media: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      predefineColors,
      animations,
      familys,
      fontSize,
      directions,
      scrollType: '0',
      options: [{
        value: '1',
        label: this.$t('cswcaa1')
      }],
      num: "",
      num1: 0,
      value: "",
    }
  },
  mounted() {
    console.log(this.media);
  },
  methods: {
    fontSet(type) {
      this.media[type] = !this.media[type];
    },
    fontColor(color) {
      console.log(color);
    },
    imgRequest(img) {
      return require("@/assets/images/program/normal/" + img);
    },
    modeChange(type) {
      this.media.ext_val_scrollDirection = parseInt(type);
    },
  },
  watch: {
    'media.ext_val_scrollDirection': {
      handler(nVal) {
        nVal === 5 && (this.scrollType = '5');
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
// @import "./css/style.scss";
.attr-rss {
  padding-right: 4px;
  .rss-item {
    min-height: 36px;
    margin: 8px 0px;
    .play-m-item {
      min-height: 36px;
      margin: 0px 0px 8px 0px;
      color: #617883;
    }
    .rss-attr {
      width: 100px;
      // font-family: 'Times New Roman';
      // font-weight: normal;
      // font-stretch: normal;
      // color: #617883;
    }
    .rss-attr-child {
      width: 130px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      .font-icon {
        width: 26px;
        margin-right: 6px;
        border: solid 1px #fff;
        border-radius: 4px;
      }
      .font-icon:hover {
        border: solid 1px #2687fe;
        background-color: #edfbff;
      }
      .select-icon {
        background-color: #c6e2ff !important;
      }
      span {
        color: #617883;
        font-size: 14px;
      }
    }
  }
  .el-checkbox {
    margin-right: 12px;
  }
}
</style>